module.exports = __webpack_public_path__ + "img/tabletennis.00acbc50.svg";